import { Button, Modal } from "@scuf/common";
import "../../../features/components/dashboard/LeftContainer/css/plantDetail.scss";
import _ from "lodash";
import { formatDate } from "../plantDetailUtils";

const SnashotModal = (props: any) => {
  const isChecked = (index: number, item: any): boolean => {
    if (props.snapShotList?.length === 3) {
      if (index === props.selectedSnapIndex) {
        props.setSelectedSnapshot?.(item.id);
        return true;
      } else return false;
    } else if (index === props.selectedSnapIndex) {
      props.setSelectedSnapshot?.(item.id);
      return true;
    }
    return false;
  };
  const isValidName = (name: string) => {
    if (!name) return false;
    const pattern = new RegExp(/^(?=.{1,30}$)[A-Za-z0-9_-]+$/);
    return pattern.test(name);
  };
  const isSnapnamePresent = (name: string) => {
    if (!name || !props.snapShotList) return false;
    let isPresent = false;
    props.snapShotList?.forEach((element: any) => {
      if (element.name === name) {
        isPresent = true;
      }
    });
    return !isPresent;
  };

  // const validateCheckBox = (checkData: any) => {
  //   let checked: boolean = false;
  //   props.snapShotList?.forEach((element: any) => {
  //     if (element.id === checkData.id) {
  //       checked =
  //         element.checked !== undefined
  //           ? element.checked
  //           : checkData.checked !== undefined
  //           ? checkData.checked
  //           : false;
  //     }
  //   });
  //   return checked;
  // };

  // const handleCheckedData = (e: any, item: any) => {
  //   props.snapShotList?.forEach((vm: any) => {
  //     if (vm.id === item.id) {
  //       if (e.target.checked) {
  //         item.checked = true;
  //         vm.checked = true;
  //         props.selectedSnapDelete.push(vm.id);
  //         const val = _.uniq(props.selectedSnapDelete);
  //         props.setSelectedSnapDelete(val);
  //       } else if (!e.target.checkedd) {
  //         item.checked = false;
  //         vm.checked = false;
  //         const newSelected: any = props.selectedSnapDelete?.filter(
  //           (cur: any) => cur.id !== item.id
  //         );
  //         props.setSelectedSnapDelete(newSelected.id);
  //       }
  //     }
  //   });
  // };
  return (
    <Modal
      size={props.header === "Create Snapshot" ? "small" : "large"}
      closeIcon={true}
      className="snapModalContainer"
      data-testid="snapshot-modal"
      onClose={() => {
        props.setSnapShotShow?.(false);
        props.setNewSnapshotName?.(null);
        props.setSelectedSnapIndex?.(0);
        props.setSelectedSnapshot?.(null);
        props.setValidName?.(false);
        props.setNamePresent?.(false);
      }}
      open={props.snapShotShow}
      id={
        props.header === "Create Snapshot"
          ? "snapshot-modal"
          : "snapshot-modal-restore"
      }
      closeOnDimmerClick={false}
    >
      <Modal.Header>{props.header}</Modal.Header>
      <Modal.Content className="contentAction">
        {props.header === "Create Snapshot" ? (
          <>
            <label className="snap-header">Snapshot Name</label>
            <input
              id="snao-name"
              onChange={(e: any) => {
                props.setNewSnapshotName?.(e.target.value);
              }}
              className="snapName"
              placeholder="Enter Snapshot Name"
              data-testid="snapshot-name-input"
              value={props.newSnapshotName}
              required
              maxLength={30}
              autoComplete="off"
            />
            {props.newSnapshotName &&
              !isSnapnamePresent(props.newSnapshotName) && (
                <span className="name-exist">
                  Snapshot with this name already exists.
                </span>
              )}
            <br />
            {props.newSnapshotName && !isValidName(props.newSnapshotName) && (
              <span className="name-exist">Please enter valid name.</span>
            )}
          </>
        ) : null}
        {props.snapShotList?.length > 0 &&
        (props.header === "Delete Snapshot" ||
          props.header === "Restore Snapshot") ? (
          <label className="snap-header">Current Snapshots</label>
        ) : null}
        {(props.header === "Delete Snapshot" ||
          props.header === "Restore Snapshot") &&
          props.snapShotList?.length > 0 &&
          props.snapShotList?.map((item: any, index: number) => {
            return (
              <div key={index} className="snap-row" data-testid="snapshot-row">
                {/* {props.header === "Create Snapshot" || */}
                {/* props.header === "Restore Snapshot" && ( */}
                <input
                  type="radio"
                  name="rowSelect"
                  className="radio-button-input"
                  checked={isChecked(index, item)}
                  data-testid="snapshot-radio-button"
                  onChange={() => {
                    props.setSelectedSnapIndex?.(index);
                  }}
                />
                {/* )}
                 {props.header === "Delete Snapshot" && ( */}
                {/* // <input
                  //   type="checkbox"
                  //   name="rowSelect"
                  //   className="checkbox-button-input"
                  //   data-testid="snapshot-check-button"
                  //   checked={validateCheckBox(item)}
                  //   onChange={(e: any) => {
                  //     handleCheckedData(e, item);
                  //   }}
                  // />
                // )} */}

                <label className="snap-text-column" data-testid="row-date">
                  {item?.dateCreated ? formatDate(item?.dateCreated) : "-- --"}
                </label>
                <label className="snap-text-column" data-testid="row-name">
                  {item?.name}
                </label>
              </div>
            );
          })}
      </Modal.Content>
      <Modal.Footer>
        <Button
          className="cancel-secondary"
          type="secondary"
          size="small"
          content="cancel"
          data-testid="snapshot-modal-cancel-button"
          onClick={() => {
            props.setSnapShotShow?.(false);
            props.setNewSnapshotName?.(null);
            props.setSelectedSnapIndex?.(0);
            props.setSelectedSnapshot?.(null);
            props.setValidName?.(false);
            props.setNamePresent?.(false);
          }}
        />
        <Button
          className={
            props.header === "Create Snapshot" &&
            props.newSnapshotName !== null &&
            props.newSnapshotName !== "" &&
            isValidName(props.newSnapshotName) &&
            isSnapnamePresent(props.newSnapshotName)
              ? "save-secondary"
              : props.header === "Restore Snapshot" &&
                props.selectedSnapshot !== null
              ? "save-secondary"
              : props.header === "Delete Snapshot" &&
                props.selectedSnapDelete?.length !== 0
              ? "save-secondary"
              : "save-secondary-disable"
          }
          type="primary"
          size="small"
          content={
            props.header === "Create Snapshot"
              ? "Create"
              : props.header === "Restore Snapshot"
              ? "Restore"
              : "Delete"
          }
          data-testid="snapshot-modal-insert-media"
          disabled={
            props.header === "Create Snapshot"
              ? !props.newSnapshotName ||
                !isValidName(props.newSnapshotName) ||
                !isSnapnamePresent(props.newSnapshotName)
              : props.header === "Delete Snapshot" &&
                props.selectedSnapDelete?.length === 0
              ? true
              : false
          }
          onClick={() => {
            if (props.header === "Create Snapshot") {
              // Improved for testability: extract logic to a function and minimize side effects
              const canCreate =
                isValidName(props.newSnapshotName) &&
                isSnapnamePresent(props.newSnapshotName);

              if (canCreate) {
                props.setValidName?.(false);
                props.setNamePresent?.(false);
                props.setSnapShotShow?.(false);
                props.setCloseConfirmModal?.(true);
              } else {
                props.setValidName?.(!isValidName(props.newSnapshotName));
                props.setNamePresent?.(
                  isValidName(props.newSnapshotName) &&
                    !isSnapnamePresent(props.newSnapshotName)
                );
              }
            } else {
              props.setSnapShotShow?.(false);
              props.setCloseConfirmModal?.(true);
            }
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SnashotModal;
